import Vue from 'vue';
import _find from 'lodash/find';
import _reject from 'lodash/reject';
import axios from 'axios';
import { request_mutations, request_state } from '../utils/store';
import { COMMENTS_DETAIL, COMMENTS_LIST } from '../api';
import { auth } from '../utils/requests';

export default {
    namespaced: true,
    state: {
        list: request_state(),
        create: request_state(),
        update: request_state(),
        remove: request_state(),
    },
    mutations: {
        ...request_mutations('comments_list', 'list'),
        ...request_mutations('comments_create', 'create'),
        ...request_mutations('comments_update', 'update'),
        ...request_mutations('comments_remove', 'remove'),

        extend_list(state, data) {
            state.list.loading = false;
            state.list.error = {};
            state.list.data.results = [...data.results, ...state.list.data.results];
            state.list.data.next = data.next;
        },
        append_list(state, comment) {
            state.list.data.results.push(comment);
        },
        change_text(state, { id, text }) {
            const comment = _find(state.list.data.results, { id });
            Vue.set(comment, 'text', text);
        },
        remove_comment(state, { id }) {
            state.list.data.results = _reject(state.list.data.results, { id });
        },
    },
    actions: {
        list({ commit }, {
            space_id, note_id, parent_id, resolved, extend, page,
        }) {
            const url = COMMENTS_LIST.replace('{space_id}', space_id).replace('{note_id}', note_id);
            page = page || 1;

            commit('comments_list_loading');
            return new Promise((resolve) => {
                axios.get(url, {
                    params: { page, resolved, parent_id },
                    ...auth(),
                }).then((response) => {
                    response.data.results = response.data.results.reverse();
                    commit(extend ? 'extend_list' : 'comments_list_success', response.data);
                    resolve(response.data);
                }).catch(error => commit('comments_list_error', error.response ? error.response.data : {}));
            });
        },
        create({ commit }, { space_id, note_id, data }) {
            const url = COMMENTS_LIST.replace('{space_id}', space_id).replace('{note_id}', note_id);

            commit('comments_create_loading');
            return new Promise((resolve) => {
                axios.post(url, data, auth()).then((response) => {
                    commit('comments_create_success', response.data);
                    commit('append_list', response.data);
                    resolve(response.data);
                }).catch(error => commit('comments_create_error', error.response ? error.response.data : {}));
            });
        },
        update({ commit }, {
            space_id, note_id, comment_id, data,
        }) {
            const url = COMMENTS_DETAIL
                .replace('{space_id}', space_id)
                .replace('{note_id}', note_id)
                .replace('{comment_id}', comment_id);

            commit('comments_update_loading');
            return new Promise((resolve) => {
                axios.patch(url, data, auth()).then((response) => {
                    commit('comments_update_success', response.data);
                    resolve(response.data);
                }).catch(error => commit('comments_update_error', error.response ? error.response.data : {}));
            });
        },
        remove({ commit }, { space_id, note_id, comment_id }) {
            const url = COMMENTS_DETAIL
                .replace('{space_id}', space_id)
                .replace('{note_id}', note_id)
                .replace('{comment_id}', comment_id);

            commit('comments_remove_loading');
            return new Promise((resolve) => {
                axios.delete(url, auth()).then((response) => {
                    commit('comments_remove_success', response.data);
                    resolve();
                }).catch(error => commit('comments_remove_error', error.response ? error.response.data : {}));
            });
        },
    },
};
